"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificationFilter = void 0;
class SpecificationFilter {
    constructor(allowedPrNumberOrigins) {
        this.allowedPrNumberOrigins = allowedPrNumberOrigins;
        this.defaultPrNumberOrigins = ['E', 'G', 'P'];
        if (this.allowedPrNumberOrigins === undefined) {
            this.allowedPrNumberOrigins = this.defaultPrNumberOrigins;
        }
    }
    filter(gvfDetailsResponse) {
        if (gvfDetailsResponse === undefined || gvfDetailsResponse.specifications === undefined) {
            return undefined;
        }
        const filteredSpecifications = gvfDetailsResponse.specifications
            .filter((specification) => this.allowedPrNumberOrigins.includes(specification.origin))
            .map((specification) => specification.codeText);
        if (filteredSpecifications.length > 0) {
            return filteredSpecifications;
        }
        else {
            return gvfDetailsResponse.specifications.map((specification) => specification.codeText);
        }
    }
}
exports.SpecificationFilter = SpecificationFilter;
//# sourceMappingURL=SpecificationFilter.js.map